import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EmailLog } from '../models/email-log-model';


@Injectable({
  providedIn: 'root'
})
export class EmailLogService {
  private readonly apiUrl = `${environment.API_URL}Conversation`;

  constructor(private http: HttpClient) {}

  getPatientEmails(patientId: number): Observable<EmailLog[]> {
    if (!patientId || patientId <= 0) {
      return throwError(() => new Error('Invalid patient ID'));
    }

    const params = new HttpParams().set('patientId', patientId);

    return this.http.get<EmailLog[]>(`${this.apiUrl}/GetPatientEmails`, { params })
      .pipe(
        map(response => response || []), // return empty array if null
        catchError(error => {
          console.error('Error fetching patient emails:', error);
          return throwError(() => error);
        })
      );
  }
  GetPatientEmails2(branchId: number) {

    return this.http.get(`${this.apiUrl}/GetPatientEmails` +'?patientId=' + branchId).
      pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          return error;
        })
      );
  }
}
